/*
  Asset state
*/
export default {
  list: [],
  dictList: []
}
